import { render, staticRenderFns } from "./MetacomTermsContent.vue?vue&type=template&id=65a5b883&lang=pug"
import script from "./MetacomTermsContent.vue?vue&type=script&lang=js"
export * from "./MetacomTermsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports